"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Breadcrumb", {
    enumerable: true,
    get: function() {
        return Breadcrumb;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useBreadcrumb = require("./useBreadcrumb");
const _renderBreadcrumb = require("./renderBreadcrumb");
const _useBreadcrumbStylesstyles = require("./useBreadcrumbStyles.styles");
const _useBreadcrumbContextValue = require("./useBreadcrumbContextValue");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Breadcrumb = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useBreadcrumb.useBreadcrumb_unstable)(props, ref);
    const contextValues = (0, _useBreadcrumbContextValue.useBreadcrumbContextValues_unstable)(state);
    (0, _useBreadcrumbStylesstyles.useBreadcrumbStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useBreadcrumbStyles_unstable')(state);
    return (0, _renderBreadcrumb.renderBreadcrumb_unstable)(state, contextValues);
});
Breadcrumb.displayName = 'Breadcrumb';
